import React, { useEffect, useState } from 'react';
import { ToastContainer, ToastContent, ToastTitle, ToastBody, ToastClose } from './styles';

interface ToastProps {
  id: string;
  title: string;
  body: string;
  conversationId?: number;
  onClose: (id: string) => void;
  onClick?: (conversationId: number) => void;
  duration?: number;
}

const Toast: React.FC<ToastProps> = ({
  id,
  title,
  body,
  conversationId,
  onClose,
  onClick,
  duration = 5000,
}) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => onClose(id), 300); // Aguardar animação de saída
    }, duration);

    return () => clearTimeout(timer);
  }, [id, duration, onClose]);

  const handleClick = () => {
    if (conversationId && onClick) {
      onClick(conversationId);
      setIsVisible(false);
      setTimeout(() => onClose(id), 300);
    }
  };

  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsVisible(false);
    setTimeout(() => onClose(id), 300);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <ToastContainer
      visible={isVisible}
      onClick={conversationId ? handleClick : undefined}
      clickable={!!conversationId}
    >
      <ToastContent>
        <ToastTitle>{title}</ToastTitle>
        <ToastBody>{body}</ToastBody>
      </ToastContent>
      <ToastClose onClick={handleClose}>
        <span role="img" aria-label="Fechar">×</span>
      </ToastClose>
    </ToastContainer>
  );
};

export default Toast;
